import { CalculatorBlock } from '@heidi/evidence';
import type { CalculatorResult } from '@heidi/evidence/contracts';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import { friendlyToolError } from '../../../../data/projects/components/projectChatMessage.helpers';
import { readString, readToolData, readToolError } from './shared/readers';
import { toCalculatingStatus } from './status';

import type { JSX } from 'react';

export const renderMedicalCalculatorToolUse = (item: ToolUseItem): JSX.Element | null => {
  const status = toCalculatingStatus(item.status);
  if (!status) return null;

  // The calculator id is the tool-call arg; the completed `data` block IS the
  // raw calculator result (CalculatorResult), not a `{ result }` wrapper.
  const calculator =
    readString(item.input, 'calculator') ??
    readString(item.input, 'calculator_id') ??
    readString(item.input, 'calculator_name');
  if (!calculator) return null;

  if (status === 'calculating') {
    return <CalculatorBlock calculator={calculator} status="calculating" />;
  }

  if (status === 'error') {
    return (
      <CalculatorBlock
        calculator={calculator}
        status="error"
        error={friendlyToolError(readToolError(item))}
      />
    );
  }

  const data = readToolData(item);
  if (!data) return null;

  return (
    <CalculatorBlock
      calculator={calculator}
      status="completed"
      result={data as CalculatorResult}
    />
  );
};
